<div class="app-header">
  <div class="sidebar-logo">
    <a href="/" target="_blank">
      <img nz-image nzSrc="/assets/images/NFL_Shield_rgb.png" nzDisablePreview="true" alt="NFL LOGO" />
    </a>
    <span class="logo-name">Enhanced Integrity Monitoring</span>
  </div>
  <div class="right-header-section">
    <div
      class="user-profile"
      nz-dropdown
      nzTrigger="click"
      [nzDropdownMenu]="menu"
      (nzVisibleChange)="dropdownToggle($event)"
    >
      <nz-avatar [nzText]="userEmail?.at(0)" [nzSize]="32" nzShape="circle"></nz-avatar>
      <span>{{ firstName }}</span>
      <span *ngIf="!isDropdownOpen" class="user-profile-down-icon" nz-icon nzType="down" nzTheme="outline"></span>
      <span *ngIf="isDropdownOpen" class="user-profile-up-icon" nz-icon nzType="up" nzTheme="outline"></span>

      <nz-dropdown-menu #menu="nzDropdownMenu">
        <nz-card class="user-info-card">
          <div class="user-info">
            <div>
              <nz-avatar nzIcon="user" [nzSize]="42" />
            </div>
            <div class="user-details">
              <span class="user-name">Hi, {{ userName }}</span>
              <span>{{ userEmail }}</span>
              <span>{{ orgName }} {{ userRole }}</span>
            </div>
          </div>
          <div class="sign-out-box">
            <button nz-button [class.clicked-button]="true" [nzLoading]="isLoading" (click)="signOut()">
              <img
                alt="sign out"
                nzDisablePreview="true"
                nz-image
                class="sign-out-img"
                nzSrc="/assets/images/sign_out_icon.svg"
              />Sign Out
            </button>
          </div>
        </nz-card>
      </nz-dropdown-menu>
    </div>
  </div>
</div>
